import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid } from '@material-ui/core';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../redux/ducks/BookDucks';
import { RootState } from '../../../redux/store';

// Components
import TableBook from '../../../components/TableBook/TableBook';
import DialogConfirm from '../../../components/DialogConfirm/DialogConfirm';
// eslint-disable-next-line max-len
import ContainerBreadcrumbs from '../../../components/ContainerBreadcrumbs/ContainerBreadcrumbs';
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
import Card from '../../../components/Card/Card';

const BookList: React.FC = () => {
  const history = useHistory();

  const [open, setOpen] = useState( false );
  const [idDoc, setIdDoc] = useState( '' );

  const dispatch = useDispatch();

  const booksInStore = useSelector(( state: RootState ) => state.book.books );

  useEffect(() => {
    dispatch( actions.getBooks());
  }, []);

  const handleOpenConfirm = ( id: string ): void => {
    setIdDoc( id );
    setOpen( true );
  };

  const handleNew = (): void => {
    history.push( `/admin/libros/agregar` );
  };

  const handleEdit = ( id: string ): void => {
    history.push( `/admin/libros/editar/${id}` );
  };

  const handleDelete = ( confirm: boolean ): void => {
    if ( confirm ) {
      dispatch( actions.deleteBook( idDoc ));
    }
    setOpen( false );
  };

  const handleShow = ( id: string ): void => {
    history.push( `/admin/libros/ver/${id}` );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card>
          <ContainerBreadcrumbs>
            <Breadcrumbs
              back={false}
              itemsLinks={[{ name: 'Libros', url: 'admin/libros' }]}
              itemsText={['Todos los libros']}
            />
          </ContainerBreadcrumbs>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <Card>
          <TableBook
            books={booksInStore}
            handleDelete={handleOpenConfirm}
            handleEdit={handleEdit}
            handleNew={handleNew}
            handleShow={handleShow}
          />
        </Card>
      </Grid>
      <DialogConfirm
        open={open}
        title="¿ Desea eliminar éste libro ?"
        onClose={handleDelete}
      />
    </Grid>
  );
};

export default BookList;
